import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getByLicense: state => licenseId => {
            return state.objs.filter(c => c.license === licenseId);
        }
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}